<template>
  <div class="plat-bar">
    <div class="plat-bar-icon icon-platform"></div>
    <div
      v-for="plat in platForms"
      :key="plat.name"
      @click="onPlatClick(plat.id)"
      :class="[
        'plat-bar-item',
        plat.icon,
        { active: currentPlatId === plat.id }
      ]"
    >
      <span v-if="!plat.icon">{{ plat.name }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { plat, platName } from '../../constants'
export default {
  name: 'platBar',
  props: {
    value: {
      type: [Number, String],
      default() {
        return 0
      }
    },
    crossPlatForm: {
      type: Boolean,
      default() {
        return true
      }
    },
    platConfigs: {
      type: Array,
      default() {
        return [
          {
            name: 'js',
            icon: 'icon-js',
            id: plat.js
          },
          {
            name: 'ios',
            icon: 'icon-ios',
            id: plat.ios
          },
          {
            name: 'android',
            icon: 'icon-android',
            id: plat.android
          }
        ]
      }
    }
  },
  data() {
    return {
      currentPlatId: null
    }
  },
  computed: {
    ...mapState({
      currentApp(state) {
        return state.bizSys.currentApp || {}
      }
    }),
    platIds() {
      let result = []
      let apps = this.currentApp.apps || []
      apps.forEach(item => {
        result.push(item.sdkPlatform)
      })
      return result
    },
    platForms() {
      let result = []
      if (this.crossPlatForm && this.platIds.length) {
        result.push({
          name: '全部',
          id: plat.all
        })
      }
      this.platConfigs.forEach(item => {
        // if (this.platIds.includes(item.id)) {
        //   result.push(item)
        // }
        // 经产品确认：未接入的平台仍显示
        result.push(item)
      })
      return result
    }
  },
  watch: {
    platForms() {
      this.init()
    },
    currentPlatId() {
      this.$emit('change', this.currentPlatId)
      this.$emit('input', this.currentPlatId)
    }
  },
  created() {
    this.init()
  },
  methods: {
    onPlatClick(id) {
      this.currentPlatId = id
    },
    init() {
      // 经产品确认：未接入的平台仍显示
      // if (!this.value || !this.platIds.includes(this.value)) {
      if (!this.value || !platName[this.value]) {
        this.currentPlatId = this.platForms[0].id
        return
      }
      this.currentPlatId = parseInt(this.value)
    }
  }
}
</script>

<style lang="sass">
@import "./styles/platBar.sass"
</style>
